import React, { Component, Fragment } from 'react';
import { HeaderListComponent } from '../../common/component/Index';
import { Table, Icon, Button } from "antd";
import { withTranslation } from "react-i18next";
import SaleReports from '../Reports/SaleReports';
import { LocalStorage } from '../../../../utils';
import DEFINE, { CONFIG_LOCAL_STORAGE, PATHS } from '../../../../constants/Define';

const dataSource = [
    {
        key: '1',
        name: 'Mike',
        age: 32,
    },
    {
        key: '2',
        name: 'John',
        age: 42,
    },
];

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: 'Address',
        key: 'address',
        render: () => (
            <span>
                <a href="/" className={`mr-2`}>
                    <Icon type="edit" />
                </a>
                <a href="/">
                    <Icon type="delete" />
                </a>
            </span>
        ),
    },
];


class Index extends Component {

    state = {
        profile: undefined,
    }

    componentWillMount(){
        const profile = LocalStorage.get(CONFIG_LOCAL_STORAGE.PROFILE);
        this.setState({ profile });
        this.checkRedirect(profile);
    }

    render() {
        const { t } = this.props;
        return (
            <Fragment>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wrapper wrapper-content">
                            {/* <BreadcrumbComponent t={t} routeBread={this.props.match.path} groupPath={`home`}/> */}
                            {/* <HeaderListComponent
                                path={this.props.match.path}
                                groupPath={'home'}
                                withoutHeader={true}
                            /> */}
                            <h2 style={{ textAlign: "center" }} className={`hmsTitleList mb-3`}>{t(`navigation.indexWelcomeTitle`)}</h2>
                            {/* <div className="row mt-4">
                                <div className="col-md-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className={`text-right`}>
                                                <button type={`submit`} className='btn btn-primary'>+ Tạo mới</button>
                                            </div>
                                            <Table dataSource={dataSource} columns={columns}/>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {this.renderContents()}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    renderContents(){
        const { profile } = this.state;
        if(profile && profile.roleId === DEFINE.GENERAL.ROLE_ID.CUSTOMER_SERVICE){
            return null
        }
        return <SaleReports hideHeader={true} />
    }

    checkRedirect(profile){
        if(!profile) return
        switch (profile.roleId) {
            case DEFINE.GENERAL.ROLE_ID.CUSTOMER_SERVICE:
                this.props.history.push(PATHS.TICKET.MY_TICKET.path);
                break;
            default:
                break;
        }
    }
}

export default withTranslation()(Index);